import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Intercepter et ignorer COMPLÈTEMENT les erreurs liées à l'Edge Function auth
// Cette fonction est maintenant redondante car le fetch personnalisé retourne toujours 200 OK
// Mais on la garde comme filet de sécurité supplémentaire
const handleEdgeFunctionError = (error: any) => {
  if (!error) return false;
  
  const errorMessage = error?.message || error?.toString() || '';
  const errorString = JSON.stringify(error || {}).toLowerCase();
  const errorStack = error?.stack || '';
  const errorName = error?.name || '';
  const errorCode = error?.code || '';
  
  // Vérifier tous les patterns possibles d'erreur Edge Function (insensible à la casse)
  const errorMessageLower = errorMessage.toLowerCase();
  const isEdgeFunctionError = 
    errorMessageLower.includes('edge function') ||
    errorMessageLower.includes('failed to send a request') ||
    errorMessageLower.includes('functions/v1/auth') ||
    errorMessageLower.includes('/functions/v1/auth') ||
    errorMessageLower.includes('functions/v1') ||
    errorMessageLower.includes('function returned a non-2xx') ||
    errorMessageLower.includes('networkerror') ||
    errorString.includes('/functions/v1/auth') ||
    errorString.includes('functions/v1/auth') ||
    errorString.includes('functions/v1') ||
    errorString.includes('edge function') ||
    errorString.includes('failed to send') ||
    errorStack.toLowerCase().includes('/functions/v1/auth') ||
    errorStack.toLowerCase().includes('functions/v1/auth') ||
    errorStack.toLowerCase().includes('functions/v1') ||
    errorName.toLowerCase().includes('edge function') ||
    errorCode.toLowerCase().includes('edge') ||
    (error?.url && (error.url.toLowerCase().includes('/functions/v1/auth') || error.url.toLowerCase().includes('functions/v1'))) ||
    (typeof error === 'string' && (error.toLowerCase().includes('edge function') || error.toLowerCase().includes('functions/v1')));
  
  if (isEdgeFunctionError) {
    // Ne pas afficher l'erreur dans la console - elle est déjà gérée par le fetch personnalisé
    return true; // Indique que l'erreur a été gérée
  }
  return false;
};

// Intercepter les promesses rejetées non gérées
window.addEventListener('unhandledrejection', (event) => {
  if (handleEdgeFunctionError(event.reason)) {
    event.preventDefault(); // Empêcher l'affichage de l'erreur
    return;
  }
});

// Intercepter les erreurs générales
window.addEventListener('error', (event) => {
  if (handleEdgeFunctionError(event.error || event.message)) {
    event.preventDefault(); // Empêcher l'affichage de l'erreur
    return;
  }
});

// Intercepter les erreurs de console.error (pour les masquer)
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  const errorString = args.join(' ');
  const firstArg = args[0];
  // Vérifier à la fois la chaîne et le premier argument (qui peut être un objet d'erreur)
  if (!handleEdgeFunctionError(errorString) && !handleEdgeFunctionError(firstArg)) {
    originalConsoleError.apply(console, args);
  }
};

// Intercepter les erreurs de console.warn (pour les masquer)
const originalConsoleWarn = console.warn;
console.warn = (...args: any[]) => {
  const errorString = args.join(' ');
  const firstArg = args[0];
  // Vérifier à la fois la chaîne et le premier argument (qui peut être un objet d'erreur)
  if (!handleEdgeFunctionError(errorString) && !handleEdgeFunctionError(firstArg)) {
    originalConsoleWarn.apply(console, args);
  }
};

// Intercepter aussi console.log pour les erreurs qui pourraient y passer
const originalConsoleLog = console.log;
console.log = (...args: any[]) => {
  const errorString = args.join(' ');
  const firstArg = args[0];
  // Ne masquer que les erreurs Edge Function, pas les autres logs
  if (!handleEdgeFunctionError(errorString) && !handleEdgeFunctionError(firstArg)) {
    originalConsoleLog.apply(console, args);
  }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);




